<template>
  <Button v-slot="slotProps" as-child>
    <RouterLink
      :class="slotProps.class"
      class="w-[132px] px-8 py-3 font-semibold!"
      to="/auth/register"
    >
      Get started
    </RouterLink>
  </Button>
</template>
